import { App, Button, Form, message, Modal } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useUpdateStatusUnloadingItem } from "features/log/use-cases/update-unloadingItemStatus";
import { useState } from "react";

type AddEntryAccpetRejectModalProps = {
  onClose: () => void;
  approveReject: "Approve" | "Reject";
  isModalOpen: boolean;
  log?: any;
  selectLogId?: any
};

export const AddExitAccpetRejectModal = ({
  onClose,
  approveReject,
  isModalOpen,
  log,
  selectLogId
}: AddEntryAccpetRejectModalProps) => {
  const [remark, setRemark] = useState("");
  const { mutateAsync } = useUpdateStatusUnloadingItem(); // ✅ use mutateAsync
  const { modal } = App.useApp();
  
  const handleApprove = () => {
    if (!remark.trim()) {
      message.error("Remark is required before proceeding.");

      return;
    }

    modal.confirm({
      title: `Are you sure you want to ${approveReject.toLowerCase()} this entry?`,
      okText: "Yes",
      cancelText: "No",
      onOk: async () => {
        try {
          const payload = {
            EntryId:log?.entryId,
            UnloadId: selectLogId,
            remarks: remark,
            IsApproved: approveReject === "Approve" ? 1 : 3,
          };

          await mutateAsync(payload); // ⏳ waits here until API resolves
          message.success(
            approveReject === "Approve"
              ? "Approved successfully"
              : "Rejected successfully"
          );
          onClose();
        } catch (err) {
          message.error("Something went wrong, please try again.");
          throw err; // ❌ keeps modal open if error occurs
        }
      },
    });
  };

  return (
    <Modal
      title={`${approveReject} Entry`}
      open={isModalOpen}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="approve" type="primary" onClick={handleApprove}>
          {approveReject}
        </Button>,
      ]}
    >
      <Form layout="vertical">
        <Form.Item
          label="Remark"
          required
          validateStatus={!remark.trim() ? "error" : ""}
          help={!remark.trim() ? "Remark is required" : ""}
        >
          <TextArea
            rows={4}
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
